import { createSlice } from "@reduxjs/toolkit";
import { globalActions } from "../actions";

const initialState = {
	items: { dict: {}, list: [] },
	requireRefresh: false,
	pagination: { totalPages: 1, totalRecords: 0, pageNumber: 1, pageSize: 0 },
};

const backorderedOrderSlice = createSlice({
	name: "backorderedOrder",
	initialState,
	reducers: {
		setBackorderedOrder: (state, action) => {
			const pagination =
				action.payload?.pagination || initialState.pagination;
			const itemsAsList = action.payload?.data || [];
			state.items.list = itemsAsList;
			for (let i = 0; i < itemsAsList.length; i++) {
				const item = { ...itemsAsList[i], listPosition: i };
				state.items.dict[item.id] = item;
			}
			state.pagination = {
				totalPages: pagination.total_pages,
				totalRecords: pagination.total_records,
				pageNumber: pagination.page_number,
				pageSize: pagination.page_size,
			};
		},
		updateBackorderedOrder: (state, action) => {
			const payload = action.payload;
			if (payload instanceof Array) {
				const items = payload;
				items.forEach((item) => {
					if (item.id in state.items.dict) {
						const itemListPosition =
							state.items.dict[item.id].listPosition;
						state.items.list[itemListPosition] = item;
						state.items.dict[item.id] = {
							...item,
							listPosition: itemListPosition,
						};
					}
				});
			} else {
				const item = payload;
				if (item.id in state.items.dict) {
					const itemListPosition = state.items.dict[item.id].listPosition;
					state.items.list[itemListPosition] = item;
					state.items.dict[item.id] = {
						...item,
						listPosition: itemListPosition,
					};
				}
			}
		},
		resetBackorderedOrder: (state) => initialState,
	},
	extraReducers: (builder) => {
		builder.addCase(globalActions.logout, () => initialState);
	},
});

const getBackorderedOrderItemsAsDict = (state) => state.backorderedOrder.items.dict;

const getBackorderedOrderItemsAsList = (state) => state.backorderedOrder.items.list;

const getBackorderedOrderRequireRefresh = (state) => state.backorderedOrder.requireRefresh;

const getBackorderedOrderPagination = (state) => state.backorderedOrder.pagination;

export {
	getBackorderedOrderItemsAsDict,
	getBackorderedOrderItemsAsList,
	getBackorderedOrderRequireRefresh,
	getBackorderedOrderPagination,
};

export default backorderedOrderSlice;
